export default __webpack_public_path__ + "static/media/rajab.7c89ed65.png";